<template lang="pug">
  .settings-consultant-dropdown
    v-dropdown(
      ref="dropdown"
      width-auto
      position-right)
      v-btn(
        icon
        :loading="loading"
        @click="onClick")
        v-icon(
          font-size="1.2"
          icon="cog")
      .settings-consultant-dropdown__content(
        v-if="loaded"
        slot="content")
        v-card(
          elevated)
          v-card-title
            h2.card-title.mb-3 {{ 'activities.user_params' | translate }}
            v-switch.mb-3(
              :label="$t('activities.activate_consultant')"
              v-model="form.is_active"
              @input="update")

          v-divider(
            secondary)

          v-card-title
            h2.card-title.mb-3 {{ 'base.action' | translate }}
          v-card-actions
            .settings-consultant-dropdown__group
              v-btn(
                small
                ghost
                @click="editClick")
                v-icon(
                  position-left
                  font-size="1"
                  icon="pencil-alt")
                span {{this.$t('activities.edit')}}
            .settings-consultant-dropdown__group
              v-btn(
                ghost
                small
                @click="changeClick")
                v-icon(
                  position-left
                  font-size="1"
                  icon="key")
                span {{ 'auth.changes_password' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SettingsConsultantDropdown',

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    form: {
      is_active: false
    },
    loading: false,
    loaded: false
  }),

  computed: {
    ...mapGetters('dashboard', [
      'currentUser'
    ])
  },

  methods: {
    ...mapActions('dashboard', [
      'getUser',
      'updateUser'
    ]),

    async onClick () {
      this.loaded = false
      this.loading = true
      await this.getUser(this.id)
      this.form.is_active = this.currentUser.is_active
      this.loading = false
      this.loaded = true
    },

    async update () {
      this.loading = true
      const payload = {
        ...this.currentUser
      }
      payload.is_active = this.form.is_active
      await this.updateUser(payload)
      this.loading = false
      this.$emit('toggled')
    },

    editClick () {
      this.$emit('edit')
      this.$refs.dropdown.closeDropdown()
    },

    changeClick () {
      this.$emit('change')
      this.$refs.dropdown.closeDropdown()
    },
  }
}
</script>

<style lang="scss" scoped>
  .settings-consultant-dropdown {
    &__content {
      width: 38rem;
    }

    &__group:not(:last-child) {
      margin-bottom: 2rem;
    }
  }
</style>
